import React from 'react';

/**
 * Downward arrow from the marketing design system: 12x12, 1.1 stroke. Used on
 * the mobile scan shortcut, which jumps down the page to the shared scanner.
 */
export function ArrowDownIcon({ className }: { className?: string }): React.ReactElement {
  return (
    <svg
      className={className}
      fill="none"
      viewBox="0 0 12 12"
      stroke="currentColor"
      strokeWidth="1.1"
      aria-hidden="true"
    >
      <path d="M6 1v9M2 6l4 4 4-4" />
    </svg>
  );
}
